import { createFileRoute } from "@tanstack/react-router"
import DesignSystemSwitches from "~/pages/design-system/components/Switches"

export const Route = createFileRoute("/_auth/internal/design-system/components/switches")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemSwitches />
}
